__turbopack_context__.v({
  "matchCountdownWrapper": "MatchCountdown-module-scss-module__j5fk8W__matchCountdownWrapper",
  "unitSeperator": "MatchCountdown-module-scss-module__j5fk8W__unitSeperator",
  "unitTimeLabel": "MatchCountdown-module-scss-module__j5fk8W__unitTimeLabel",
  "unitTimeWrapper": "MatchCountdown-module-scss-module__j5fk8W__unitTimeWrapper",
  "unitsLeft": "MatchCountdown-module-scss-module__j5fk8W__unitsLeft",
});
